import React from 'react';

import styled from 'styled-components';

const ScreenshotThumbnail = styled.img`
  display: block;
  width: 120px;
  height: 68px;
  object-fit: cover;
  border: 1px solid var(--line-gray);
  border-radius: 4px;
`;

type Props = {
  artifactUrl: string;
  label: string;
  dataTestId: string;
  thumbnail?: boolean;
};

const RecommendationEvidenceArtifactLink = ({ artifactUrl, label, dataTestId, thumbnail = false }: Props) => {
  return (
    <a href={artifactUrl} target="_blank" rel="noopener noreferrer" data-test-id={dataTestId}>
      {thumbnail ? <ScreenshotThumbnail src={artifactUrl} alt={label} /> : label}
    </a>
  );
};

export default RecommendationEvidenceArtifactLink;
